/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Createanothereventtoengageyouraudience6Inputs */

const en_createanothereventtoengageyouraudience6 = /** @type {(inputs: Createanothereventtoengageyouraudience6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create another event to engage your audience`)
};

const de_createanothereventtoengageyouraudience6 = /** @type {(inputs: Createanothereventtoengageyouraudience6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstell ein weiteres Event für dein Publikum.`)
};

/**
* | output |
* | --- |
* | "Create another event to engage your audience" |
*
* @param {Createanothereventtoengageyouraudience6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const createanothereventtoengageyouraudience6 = /** @type {((inputs?: Createanothereventtoengageyouraudience6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Createanothereventtoengageyouraudience6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_createanothereventtoengageyouraudience6(inputs)
	return de_createanothereventtoengageyouraudience6(inputs)
});
export { createanothereventtoengageyouraudience6 as "createAnotherEventToEngageYourAudience" }